import $ from 'jquery';
import FJUtil from './FJUtil';
import FJImageUtil from './FJImageUtil';
import FJPoolStore from '../store/FJPoolStore';
let po = null;

const FJSVGUtil = {
    insertFontToSvg: function (svg, fontDataArr, options = {}) {
        const { success, error, usePoolImage } = options;
        const styles = $(svg).find('style')[0];
        $(styles).text('');
        fontDataArr.forEach(({ fontName, bold, italic, fontBase64 }) => {
            const textNode = document.createTextNode(
                '' +
                    '* {box-sizing: border-box}' +
                    ' @font-face {font-family: "' +
                    fontName +
                    '";' +
                    'font-style:' +
                    (italic ? 'italic;' : 'normal;') +
                    'font-weight:' +
                    (bold ? '700;' : '400;') +
                    'src: url("data:application/font-woff;charset=utf-8;base64,' +
                    fontBase64 +
                    '");}',
            );
            $(styles).append(textNode);
        });
        this.svgToImage(svg, { success, error, usePoolImage });
    },

    svgToImage: function (svg, options = {}) {
        (async () => {
            const { success, error, usePoolImage } = options;
            try {
                const image = usePoolImage ? FJPoolStore.getImage() : new Image();
                const url =
                    'data:image/svg+xml;charset=utf-8,' +
                    encodeURIComponent(new XMLSerializer().serializeToString(svg));

                image.setAttribute('fetchpriority', 'high');
                image.setAttribute('loading', 'eager');

                if (FJUtil.getBrowser() === 'Safari') {
                    image.decoding = 'sync';
                }

                await FJImageUtil.loadImage(url, image);

                if (FJUtil.getBrowser() === 'Safari') {
                    await FJUtil.wait(0.05);
                    await FJUtil.polling(() => image.complete, 20, 2000);
                }

                success && success(image);
            } catch (e) {
                error && error(e);
            }
        })();
    },

};

export default FJSVGUtil;
